import { StateNode } from "./node.state";
export class ContextNode extends StateNode {
  ignoreEventsParent = true;
}
